import { useState, useEffect, memo } from "react";
import { Popover, QRCode } from "antd";
import cls from "classnames";
import { useTranslation } from "react-i18next";
import { AppleFilled, AndroidFilled } from "@ant-design/icons";
import { ReactComponent as QRCodeIcon } from "logic/src/components/icons/qrcode.svg";
// import { ReactComponent as AppIcon } from "@/assets/images/app.svg";
import styles from "./index.module.scss";
import favicon from "../../../public/favicon_hk.png";

const OVERLAY_STYLES = {
  padding: 0,
  marginTop: 10,
  backgroundColor: "#FFF",
  borderRadius: 8,
  boxShadow: "0px 15px 30px 0px rgba(197, 204, 196, 0.20)",
};

const AppQRCode = ({
  className,
  right,
}: {
  className?: string;
  right?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <Popover
      placement={right ? "right" : "top"}
      trigger="hover"
      overlayInnerStyle={OVERLAY_STYLES}
      arrow={false}
      content={
        <div className={styles.qrCodeContainer}>
          <div className={styles.qrCodeItem}>
            <QRCode
              className={styles.qrCodeImg}
              size={126}
              iconSize={32}
              bordered={false}
              errorLevel="H"
              value="https://apps.apple.com/hk/app/sensechat-%E5%95%86%E9%87%8F/id6483941793"
              icon={favicon}
            />
            <div className={styles.qrCodeName}>
              {/* IOS */}
              <AppleFilled className={styles.icon} /> {t("sensechat-160")}
            </div>
          </div>
          <div className={styles.qrCodeItem}>
            <QRCode
              className={styles.qrCodeImg}
              bordered={false}
              iconSize={32}
              errorLevel="H"
              size={126}
              icon={favicon}
              value="https://play.google.com/store/apps/details?id=com.sensetime.chat&pli=1"
            />
            {/* <img className={styles.qrCodeImg} src={androidUrl}></img> */}
            <div className={styles.qrCodeName}>
              {/* 安卓 */}
              <AndroidFilled
                data-ti="feedback_click"
                data-tn="意见反馈点击"
                className={styles.icon}
              />{" "}
              {t("sensechat-161")}
            </div>
          </div>
        </div>
      }
    >
      <span
        data-ti="app_download_hover"
        data-tn="APP下载hover"
        data-tt="hover"
        className={cls(styles.qrCodeBtn, className)}
      >
        {/* 下载App */}
        <QRCodeIcon className={styles.qrcodeIcon} />
      </span>
    </Popover>
  );
};

export default memo(AppQRCode);
